import { Controller } from "@hotwired/stimulus"
import { sendMarketingEvent } from "../lib/marketing_events"

export default class extends Controller {
  static targets = ["field"]
  static values = { storageScope: String }

  connect() {
    this.restore()
    sendMarketingEvent("project_intake_step_viewed", { step: "quick_start" })
  }

  save() {
    const draft = {}
    this.fieldTargets.forEach((field) => {
      draft[field.dataset.draftKey] = field.value
    })
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(draft))
    } catch (_error) {
      // Storage may be disabled; the form remains fully usable without drafts.
    }
  }

  submitted(event) {
    if (!event.detail.success) return

    try {
      localStorage.removeItem(this.storageKey)
    } catch (_error) {
      // Storage may be disabled.
    }
  }

  restore() {
    try {
      const serialized = localStorage.getItem(this.storageKey)
      if (!serialized) return

      const draft = JSON.parse(serialized)
      this.fieldTargets.forEach((field) => {
        const value = draft[field.dataset.draftKey]
        if (typeof value === "string") field.value = value
      })
    } catch (_error) {
      try {
        localStorage.removeItem(this.storageKey)
      } catch (_storageError) {
        // Storage may be disabled.
      }
    }
  }

  get storageKey() {
    return `munibot:quick-project-draft:${this.storageScopeValue}`
  }
}
